module.exports = __webpack_public_path__ + "static/media/46.0ca45a99.png";